<template>
  <div>
    <production-chart
      v-if="healthData"
      :key="healthData.id"
      :graph-data="healthData.seriesData"
      :x-axis-rotate="90"
      :legend="false"
      :only-percent="true"
    />
  </div>
</template>
<script>
import store from '@/store/index'
import { defineComponent, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ProductionChart from '@core/components/charts/echart/ProductionChart.vue'

export default defineComponent({
  components: {
    ProductionChart,
  },
  props: {
    lineAssets: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const toast = useToast()
    const healthData = ref(null)
    const total = ref(0)
    const now = new Date()
    const endTime = Date.now()
    const startTime = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000).getTime()
    const fetchAssets = () => {
      const filteredData = props.lineAssets.filter(item => [57, 83, 44, 34, 22].includes(item.assetID))
      const asset = filteredData[0]
      store
        .dispatch('app-asset-main/fetchGraph', { assetID: asset.assetID, type: 'glovecounttrend' })
        .then(response => {
          const { data } = response
          console.log(data)
          total.value = endTime - startTime
          healthData.value = data
          console.log(healthData.value)
        })
        .catch(e => {
          console.log(e)
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error fetching data from server',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    fetchAssets()

    return {
      healthData,
      total,
    }
  },
})
</script>
